const list = [
  {
    name: 'Sponges-S',
    cName: '方形种植棉',
    id: 'accessories-1',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/zhongzhimian-fang.png',
  },
  {
    name: 'Container Kit-S',
    cName: '方形种植篮',
    id: 'accessories-2',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/zhongzhilan-fang.png',
    hidden: true,
  },
  {
    name: 'Germination hood-S',
    cName: '方形发芽罩',
    id: 'accessories-3',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/fayazhao-fang.png',
  },
  {
    name: 'Basket Lable-S',
    cName: '方形种植篮贴纸',
    id: 'accessories-4',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/tiezhi-fang.png',
    hidden: true,
  },
  {
    name: 'Planter Cover-S',
    cName: '方形水箱小盖',
    id: 'accessories-5',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/gaizi-fang-heise.png',
  },
  {
    name: 'Sponges-R',
    cName: '圆形种植棉',
    id: 'accessories-6',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/zhongzhimian-yuan.png',
  },
  {
    name: 'Container Kit-R',
    cName: '圆形种植篮',
    id: 'accessories-7',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/zhongzhilan-yuan.png',
    hidden: true,
  },
  {
    name: 'Germination hood-R',
    cName: '圆形发芽罩',
    id: 'accessories-8',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/fayazhao-yaun.png',
  },
  {
    name: 'Basket Lable-R',
    cName: '圆形种植篮贴纸',
    id: 'accessories-9',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/tiezhi-yaun.png',
    hidden: true,
  },
  {
    name: 'Planter Cover-R',
    cName: '圆形水箱小盖',
    id: 'accessories-10',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/gaizi-yuan-heise.png',
  },
  {
    name: 'Plant Food A 100ml',
    cName: '100ml肥料A',
    id: 'accessories-11',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/100ml-feiliao-A.png',
  },
  {
    name: 'Plant Food B 100ml',
    cName: '100ml肥料B',
    id: 'accessories-12',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/100ml-feiliao-B.png',
  },
  {
    name: 'Plant Food A 50ml',
    cName: '50ml肥料A',
    id: 'accessories-13',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/50ml-feiliao-A.png',
  },
  {
    name: 'Plant Food B 50ml',
    cName: '50ml肥料B',
    id: 'accessories-14',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/50ml-feiliao-B.png',
  },
  {
    name: 'Rod',
    cName: '支撑管硬管',
    id: 'accessories-15',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/yingguan.png',
    hidden: true,
  },
  {
    name: 'Plant Label',
    cName: '种植标签',
    id: 'accessories-16',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/zhongzhibiaoqian.png',
    hidden: true,
  },
  {
    name: 'Adapter',
    cName: '适配器',
    id: 'accessories-17',
    template: 'product-common',
    img: 'http://igstech.com.cn/resources/nva/peijian/shipeiqi.png',
    hidden: true,
  },
]

export default {
  name: 'all',
  // 图文
  imageText: [
    // 所有配件
    {
      type: 'formwork10',
      list: list,
    },
  ],
}
const getPack = (id) => {
	return list.find((item) => item.id === id)
}
/** 根据 配件的id 返回 配件列表*/
export const getPacks = (packs = []) => {
	const result = []
	packs.forEach(item => {
		let pack = getPack(item.id)
		if (pack) {
			pack.num = item.num
			result.push({
				...pack,
				num: item.num,
			})
		}
	})
	return result;
}
